import { useEffect, useMemo, useState } from 'react';
import { DEFAULT_CLIENT_PAGE_SIZE, type DataTableClientPagination } from '@wapharma/design-system';

export type UseClientTablePaginationOptions = {
  /** When false, fixed `pageSize` (drawers / capped `maxBodyHeight`). Default true. */
  fitViewport?: boolean;
};

/** Client-side DataTable pagination with page reset when `resetDeps` change. */
export function useClientTablePagination(
  pageSize = DEFAULT_CLIENT_PAGE_SIZE,
  resetDeps: readonly unknown[] = [],
  options?: UseClientTablePaginationOptions,
): {
  pageIndex: number;
  setPageIndex: (index: number) => void;
  pagination: DataTableClientPagination;
} {
  const fitViewport = options?.fitViewport ?? true;
  const [pageIndex, setPageIndex] = useState(0);
  useEffect(() => {
    setPageIndex(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- caller passes filter deps intentionally
  }, resetDeps);

  const pagination = useMemo(
    (): DataTableClientPagination => ({
      mode: 'client',
      pageSize,
      pageIndex,
      onPageIndexChange: setPageIndex,
      fitViewport,
    }),
    [pageSize, pageIndex, fitViewport],
  );

  return { pageIndex, setPageIndex, pagination };
}
